require("./src/gatsby-theme-docz/themes/darcula.css")
require("prismjs/plugins/command-line/prism-command-line.css")
require("prismjs/plugins/line-numbers/prism-line-numbers.css")
require("./src/gatsby-theme-docz/themes/prism-addon.css")
